import type { Dictionary } from '../i18n/dictionary';
import type { Story } from '../lib/story';
import { Stat, StatGrid } from './Stat';

const sample: Dictionary<{
  balance: string;
  shortfall: string;
  today: string;
  ofLimit: string;
}> = {
  pl: {
    balance: 'Saldo',
    shortfall: 'Niedobór',
    today: 'Dziś',
    ofLimit: 'z 2 000 kcal',
  },
  en: {
    balance: 'Balance',
    shortfall: 'Shortfall',
    today: 'Today',
    ofLimit: 'of 2,000 kcal',
  },
};

export default {
  kind: 'component',
  title: { pl: 'Statystyka', en: 'Stat' },
  description: {
    pl: 'Jedna liczba na własnej karcie. `StatGrid` układa je w jedną kolumnę na telefonie i trzy od md. `tone="danger"` dla złej wiadomości; `children` to przypis pod wartością.',
    en: 'One headline number on its own card. `StatGrid` lays them out one column on a phone, three from md. `tone="danger"` for bad news; `children` is a footnote under the value.',
  },
  variants: [
    {
      name: { pl: 'Siatka', en: 'Grid' },
      render: (locale) => (
        <StatGrid>
          <Stat label={sample[locale].balance} value="12 480,00 zł" />
          <Stat
            label={sample[locale].shortfall}
            value="−1 250,00 zł"
            tone="danger"
          />
          <Stat label={sample[locale].today} value="1 640">
            <p className="text-hint">{sample[locale].ofLimit}</p>
          </Stat>
        </StatGrid>
      ),
    },
  ],
} satisfies Story;
